var map = {
	"./Bahubali hills Udaipur.jpeg": 290,
	"./Gwalior fort.jpeg": 5124,
	"./Meenakshi Temple.jpeg": 9974,
	"./badrinath.jpeg": 1631,
	"./chilika-lake.jpg": 3634,
	"./darhjeeing.png": 7296,
	"./devprayag.jpeg": 9559,
	"./golden temple.jpeg": 3902,
	"./harihar.fort.jfif": 508,
	"./jagannath puri.jpeg": 9434,
	"./jatayu parl.jpeg": 406,
	"./kailash temple.png": 9807,
	"./kedarkanth trek.jpeg": 8783,
	"./konark sun temple.jpeg": 7863,
	"./kumbhalgarh.jpeg": 9698,
	"./lal chowk.jpg": 6258,
	"./nalsarver.png": 8011,
	"./packages banner.jpg": 1488,
	"./rameshrvam temple.jpg": 4206,
	"./tiruati.jpeg": 8382,
	"./tungnath.jfif": 4297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9971;